import { normalizeTranslateValue } from "@gameApp/helpers/canvas/normalizeTranslateValue";
import type { BasicDrawOptions } from "@gameApp/helpers/canvas/types";

export function applyTranslate(options: BasicDrawOptions): void {
  const { context, translateX, translateY } = options;

  const hasTranslate =
    Number.isFinite(translateX) || Number.isFinite(translateY);

  if (hasTranslate) {
    context.save();

    context.translate(
      normalizeTranslateValue(translateX),
      normalizeTranslateValue(translateY),
    );
  }
}

export function restoreTranslate(options: BasicDrawOptions): void {
  const { context, translateX, translateY } = options;

  const hasTranslate =
    Number.isFinite(translateX) || Number.isFinite(translateY);

  if (hasTranslate) {
    context.restore();
  }
}
